import { Restaurant } from "App/domain/entities/restaurant";

export const restaurantService = {
    isValidForToTableOrders(restaurant: Restaurant) {
        return restaurant.is_active && restaurant.is_active_for_to_table_orders && restaurant.number_of_tables > 0;
    }
}